'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("printToolbar", function ($window, $print) {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: require("./printToolbar.html"),
    link: function link($scope, $el, $attrs, ctrl) {
      $scope.printPage = function () {
        $window.print();
      };
      $scope.exitPrintMode = function () {
        $print.disablePrint();
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/print/printToolbar.js
// module id = 2719
// module chunks = 13